<template>
  <div style="background-color: #f2f2f2; height: 100vh">
    <div
      style="
        background-color: #f2f2f2;
        display: grid;
        grid-template-rows: 1fr;
        align-items: center;
        justify-items: center;
      "
    >
      <v-icon style="margin-top: 50px; margin-bottom: 50px; font-size: 5rem; color: #fec72f">mdi-tools</v-icon>
      <span style="font-weight: 600; color: black">Server Error</span>
      <span>Sorry, our site is experiencing some technical problems with Google Chrome.</span>
      <span
        >Please try different browser like <span style="font-weight: 600; color: black">Safari or Firefox</span></span
      >
      <span>
        <a :href="ulcPartnerFlag ? 'https://ulc.asu.edu/contact-us/' : 'https://ea.asu.edu/contact/'" target="_blank"
          >contact our support team</a
        >
        for assistance.
      </span>
      <span v-if="referenceId">Error Code: {{ referenceId }}</span>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  data() {
    return {};
  },

  mixins: [AjaxLoader, Helper],

  props: {
    referenceId: {
      type: String
    }
  },

  computed: {
    loginch: function () {
      return this.$auth.isAuthenticated();
    },
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    }
  },

  mounted() {}
});
</script>
